import React from 'react';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import BillDetailsContainer from './BillDetailsContainer';

const BillDetailsScene = (props) => (
  <>
    <Breadcrumb
      crumbs={[
        ...(props.location.state && props.location.state.from
          ? [{ text: props.location.state.from.text, link: props.location.state.from.pathname }]
          : []),
        {
          text: 'Bill Details',
        },
      ]}
    />
    <BillDetailsContainer billId={props.params.billId} />
  </>
);

export default BillDetailsScene;
